import { useAuth } from '../../../../../context/AuthContext'
import { SpaceLoader } from '../../../../loaders/spaceLoader'
import { api } from '../../../../../services/api';
import { BarGraphics } from '../BarGraphics';
import { useEffect, useState,useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import { ExportFiles } from '../ExportFiles'
import { FiMoreVertical } from 'react-icons/fi'
import { FaFilter } from 'react-icons/fa'
import { download_csv } from '../JsonToCsv'
import moment from 'moment'
import { ContainerThatCloseOutside } from '../../../../ContainerThatCloseOutside';

import { Container, ContainerLoading, Button } from './style'


export function RankingDetailedInformations() {
    const { signOut } = useAuth()
    const rankingDatas = useSelector(state => state.modalCentralized.datasComponent)
    const history = useHistory()
    const ref = useRef(null)

    const [isLoading, setIsLoading] = useState()
    const [ranking, setRanking] = useState([])
    const [loadingButton, setLoadingButton] = useState(false)
    const [page, setPage] = useState(1)
    const [isOpenExcelButton, setIsOpenExcelButton] = useState(false)
    const [fetchingExcelData, setFetchingExcelData] = useState(false)
    const [quantDays,setQuantDays] = useState('');
    const [open,setOpen] = useState(false);


    async function handleFetchNewDates() {
        setLoadingButton(true)
    
        try{
            const response = await api.post(`/getResumeRanking/?page=${page}` ,
            {
                rankingDatas,
                quantDays
            }
            , {
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            })

            const { businesses, next_page } = response.data
    
            setRanking([...ranking, ...businesses])
            setPage(next_page)
            setLoadingButton(false)

        }catch(error){
            //console.log(error)
            signOut()
            history.push('/login')
            toast.error('Ops, algo deu errado')
        }
    }


    async function handleDownloadCSV() {
        setFetchingExcelData(true)
        const titleCSV = `Ranking_${moment(ranking.startDate).format('DD-MM-YYYY-HH:mm')}ate${moment(ranking.endDate).format('DD-MM-YYYY-HH:mm')}`

        const response = 
            await api.get(`/getExportRankingToExcel/?business=${rankingDatas.business}&startDate=${rankingDatas.startDate}&endDate=${rankingDatas.endDate}&salesChannels=${rankingDatas.salesChannels}&quantDays=${quantDays}`)
    
        
        const { success, datas } = response.data

        if(!success){
            signOut()
            history.push('/login')
            setFetchingExcelData(false)
            toast.error('Algo deu errado, faça o login novamente')
            return
        }

        download_csv(datas, titleCSV)
        setFetchingExcelData(false)
    }


    useEffect(() => {
        async function fetchData() {
            setIsLoading(true)
        
            try{
                const response  = await api.post('/getResumeRanking/?page=1' ,
                    {
                        rankingDatas
                    }
                   ,{
                    headers: {
                        'Content-Type': 'application/json',
                        token: localStorage.getItem('@Inoveclube:token')
                    }
                })
                //console.log(response)
                const { businesses, next_page } = response.data

                if(businesses === undefined)
                    throw new Error()
               
                setRanking(businesses)
                setPage(next_page)

                
    
            }catch(error){
                //console.log(error)
                signOut()
                history.push('/login')
                toast.error('Algo deu errado, faça o login novamente')
            }
            setIsLoading(false)
        }
        fetchData()
    }, [rankingDatas, signOut, history])

    const filterRankings = useCallback(async (event) => {
        event.preventDefault()
        setIsLoading(true)
        
        try{
            const response  = await api.post('/getResumeRanking/?page=1' ,
                {
                    rankingDatas,
                    quantDays
                }
               ,{
                headers: {
                    'Content-Type': 'application/json',
                    token: localStorage.getItem('@Inoveclube:token')
                }
            })
            //console.log(response)
            const { businesses, next_page } = response.data

            if(businesses === undefined)
                throw new Error()
           
            setRanking(businesses)
            setPage(next_page)

        }catch(error){
            //console.log(error)
            signOut()
            history.push('/login')
            toast.error('Algo deu errado, faça o login novamente')
        }
        setOpen(false)
        setIsLoading(false)
    },[history, quantDays, rankingDatas, signOut])

    


    if(isLoading){
        return(
            <ContainerLoading>

                <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />

            </ContainerLoading>
        ) 
    }
   
    return(
        <Container>
            <div className="seeMore"> 
                <FiMoreVertical 
                    onClick={() => setIsOpenExcelButton(!isOpenExcelButton)}
                />
                
                <ExportFiles 
                    handleDownloadCSV={handleDownloadCSV}
                    fetchingCSVData={fetchingExcelData}
                    isOpen={isOpenExcelButton}
                    setIsOpen={setIsOpenExcelButton}
                />
            </div>

            <div className='filterContainer'>
                <FaFilter
                    onClick={() => setOpen(!open)}
                />
                
                {
                    open &&
                    <ContainerThatCloseOutside
                        handleClickOutside={() => setOpen(false)}
                        availableToClick={open}
                        ref={ref}
                    >
                        <form className='filter' onSubmit={filterRankings}>
                            <span>Inaugurado a mais de: </span>
                            <input
                                type={'number'}
                                placeholder='Digite a quantidade de dias'
                                value={quantDays}
                                onChange={(event) => setQuantDays(event.target.value)}
                            />
                            <button type='submit'>Filtrar</button>
                        </form>
                    </ContainerThatCloseOutside>
                }

            </div>
          
            <BarGraphics 
                    datasForGraphic={ranking}
                    filter={true}
                    isButtonFilterVisible={true}
            />


            {page !== null &&
            <Button 
                onClick={handleFetchNewDates}
                loadingButton={loadingButton}
            >
                {
                    loadingButton ? 
                    '...aguarde'
                    :
                    'Ver mais'
                }
            </Button>}

        </Container>
    )
}
